module.exports = __webpack_public_path__ + "img/CMHKBEFORE_02_zhCn.92d189a6.png";